import React, {ReactElement, Component, useState, useEffect, Dispatch, SetStateAction, useContext} from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import {
    http_get,
    loading_alert_before,
    loading_alert_after,
    alert,
    http_put, http_delete, http_post,
} from '../common-file/service';

// 组建
import BodyTitleCard from '../component/body-title-card';
import TableList from '../component/table';
import Modals from '../component/modal';

// 全局变量
import {ServiceNameContext} from '../contexts/service-name-select';
import {ModalVisibleContext} from '../contexts/modal-visible';
import {ModalDataContext} from '../contexts/modal-data';
import {SearchValueContext} from "../contexts/search-value";
// import {AppLocationContext} from '../contexts/app-location';
import {TableListDataContext} from '../contexts/table-list-data';
import {ModalLoadingContext} from '../contexts/modal-loading';
import {ReloadServiceListContext} from '../contexts/reload-service-list';
import { DatacenternameContext } from "../../../contexts/datacenter-name";

// data type
import {modalType, modalDataType} from '../common-file/interfaceType';
import {BrokerPlanResultContext} from "../contexts/broker-plan-result";

const columns = ['service_name', 'plan', 'broker_url', 'broker_service_id', 'broker_plan_id', 'bindable'];

const ResourceService: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> => {

    const {intl} =props,
        [datasource, set_datasource]:[any, Dispatch<SetStateAction<any>>] = useState([]),
        [filter_datasource, set_filter_datasource]: [any, Dispatch<SetStateAction<any>>] = useState([]),
        service_name: string = useContext(ServiceNameContext)[0],
        [modal_visible, set_modal_visible]: [modalType, Dispatch<SetStateAction<modalType>>] = useContext(ModalVisibleContext),
        [modal_data, set_modal_data]: [modalDataType, Dispatch<SetStateAction<modalDataType>>] = useContext(ModalDataContext),
        [reload_list, set_reload_list]: [boolean, Dispatch<SetStateAction<boolean>>] = useState(()=> false),
        set_reload_service_list: Dispatch<SetStateAction<boolean>> =useContext(ReloadServiceListContext)[1],
        search_value: any = useContext(SearchValueContext)[0],
        datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
        // app_location: string = useContext(AppLocationContext)[0],
        [table_list_data, set_table_list_data] : [any, Dispatch<SetStateAction<any>>] =useContext(TableListDataContext),
        set_modal_loading: Dispatch<SetStateAction<boolean>> = useContext(ModalLoadingContext)[1],
        set_broker_plan_result: Dispatch<SetStateAction<[]>> = useContext(BrokerPlanResultContext)[1];

    useEffect(()=>{
      datacenter_name && set_reload_list(true);
    },[service_name, datacenter_name]);

    useEffect(()=>{
        if(service_name && reload_list && datacenter_name){
            reload_list&&set_reload_list(false);
            (async () => {
                set_filter_datasource([]);
                loading_alert_before();
                const {data} = await http_get(`/serviceHub/v2/servicebrokers?displayName=${service_name=== '-1'? '': service_name.replace(/\+/g, '%2B')}&datacenterCode=${datacenter_name}`, props) as any || {};
                let context_list: any =table_list_data, list:any = [];
                if(data?.brokers){
                    // eslint-disable-next-line
                    data.brokers.map((item:any, key: any) =>{
                        const {
                            bindable,
                            brokerPassword,
                            brokerPlanId,
                            brokerServiceId,
                            brokerUrl,
                            planName,
                            serviceName,
                            brokerUser,
                            displayName,
                        } = item;
                        list.push({
                            key: key,
                            service: displayName,
                            plan: planName,
                            brokerUrl,
                            brokerServiceId,
                            brokerPlanId,
                            bindable,
                            brokerPassword,
                            brokerUser,
                            displayName: serviceName,
                       });
                    });
                }
                context_list.service_management_list = list;
                set_datasource(list);
                set_table_list_data(context_list);
                loading_alert_after();
            })()
        }
        // eslint-disable-next-line
    },[service_name, reload_list, datacenter_name]);

    useEffect(()=>{
        if(modal_visible.toggle){
            let title: string ='', content='', type= '', itemValue: any={};
            switch (modal_visible.type){
                case 'delete': title = 'confirm';
                    content = 'delete_service_broker';
                    type = 'delete';
                    break;
                case 'create': title = 'create_broker_title';
                    type = 'create';
                    break;
                case 'update': title = 'update_broker_title';
                    type = 'update';
                    itemValue = JSON.parse(sessionStorage.getItem('service_management_item_selected') || '{}') as any;
                    break;
                default: break;
            }
            title && set_modal_data({
                title: title,
                type: type,
                confirmContent: <FormattedMessage id={content}/>,
                datasource: datasource,
                itemValue
            })
        }
        // eslint-disable-next-line
    }, [modal_visible, set_modal_data]);

    useEffect(()=>{
        if (search_value.serviceManagement) {
            set_filter_datasource(datasource.filter((item: any) => item.instanceName.toLocaleLowerCase().indexOf(search_value.serviceManagement.toLocaleLowerCase()) > -1));
        } else {
            set_filter_datasource(datasource);
        }
    }, [search_value, datasource]);

    useEffect(()=>{
        if(modal_data.formValue) {
            switch (modal_data.title) {
                case 'create_broker_title':
                    (() => {
                        loading_alert_before();
                        const {
                            brokerServiceName,
                            brokerDisplayName,
                            protocol,
                            brokerHost,
                            bindable,
                            username,
                            password,
                            serviceId,
                            planId,
                            brokerPlanList
                        } = modal_data.formValue;
                        let form_data: any = {
                            datacenterCode: datacenter_name,
                            brokerUrl: `${protocol}://${username}:${password}@${brokerHost}`,
                            brokerUser: username,
                            brokerPassword: password,
                            displayName: brokerServiceName,
                            serviceName: brokerDisplayName,
                            brokerServiceId: serviceId,
                            brokerPlanId: planId,
                            bindable
                        };
                        let value_num: number = 0, post_num:number = 0, set_or_not: boolean = true, broker_result: any =[];
                        const post_fun = async (i: number)=>{
                            const create_instance: any = await http_post('/serviceHub/v2/servicebrokers', {
                                ...form_data,
                                planName: brokerPlanList[i]
                            }, props);
                            post_num++;
                            if (create_instance) {
                                broker_result[i] = 1
                            } else {
                                broker_result[i] = 2;
                                set_or_not = false;
                            }
                            if (value_num === post_num) {
                                if (set_or_not) {
                                    set_reload_service_list(true);
                                    set_reload_list(true);
                                    set_modal_visible({toggle: false});
                                    set_broker_plan_result([]);
                                    alert('success', intl.formatMessage({id: modal_data.title}), intl.formatMessage({id: 'create_success_sp'}));
                                } else {
                                    set_broker_plan_result(broker_result);
                                    set_modal_loading(false)
                                }
                            }
                        };
                        for (let i=0;i<brokerPlanList.length;i++){
                            if(brokerPlanList[i]) {
                                value_num++;
                                post_fun(i);
                            }
                        }
                        loading_alert_after();
                    })();
                    break;
                case 'update_broker_title':
                    (async () => {
                        loading_alert_before();
                        const {
                                brokerServiceName,
                                brokerPlan,
                                brokerDisplayName,
                                bindable,
                                brokerUrl,
                                username,
                                password,
                                serviceId,
                                planId
                            } = modal_data.formValue,
                            form_data: object = {
                                datacenterCode: datacenter_name,
                                brokerUrl,
                                brokerUser: username,
                                brokerPassword: password,
                                displayName: brokerServiceName,
                                serviceName: brokerDisplayName,
                                planName: brokerPlan,
                                brokerServiceId: serviceId,
                                brokerPlanId: planId,
                                bindable
                            },
                            update_res: any = await http_put('/serviceHub/v2/servicebrokers', form_data, props);
                        if (update_res) {
                            set_reload_list(true);
                            set_reload_service_list(true);
                            set_modal_visible({toggle: false});
                            alert('success', intl.formatMessage({id: 'update'}), intl.formatMessage({id: 'update_success'}))
                        } else {
                            set_modal_loading(false)
                        }
                        loading_alert_after();
                    })();
                    break;
                case 'confirm':
                    if(modal_data.type === 'delete'){
                        (async ()=>{
                            loading_alert_before();
                            const {
                                    plan,
                                    service,
                                } = JSON.parse(sessionStorage.getItem('service_management_item_selected') || '{}') as any,
                                delete_res: any = await http_delete(`/serviceHub/v2/servicebrokers/datacenterCode/${datacenter_name}/displayName/${service}/planName/${plan}`, null, props);
                            if(delete_res){
                                set_reload_service_list(true);
                                alert('success', intl.formatMessage({id: 'delete'}), intl.formatMessage({id: 'delete_success'}))
                            }
                            set_reload_list(true);
                            loading_alert_after();
                        })()
                    }
                    break;
                default: break;
            }
        }
        // eslint-disable-next-line
    }, [modal_data, set_modal_visible]);

    return (
        <div>
            <BodyTitleCard
                card_title={{
                    name: 'service_management_title',
                    subscription: 'service_management_subscription'
                } as any}
                formList={{
                    select:{
                        service: true
                    },
                    input: [{
                        key: 'input',
                        xs: 12,
                        sm: 16,
                        md: 18,
                        lg: 20,
                        xxl: 21,
                        disabled: true
                    }],
                    add: true
                } as any}
            />
            <div className={'mt-20 no_pointer'}>
                <div>
                    <TableList
                        datasource={filter_datasource.length>0? filter_datasource: search_value.serviceManagement? []: table_list_data.service_management_list}
                        columns={columns as any}
                        action={{update: true, delete: true} as any}
                    />
                </div>
            </div>
            <Modals />
        </div>
    )
};

export default injectIntl(ResourceService);
